<template>
  <BankDetailsForm />
</template>

<script>
import BankDetailsForm from "@/components/bankdetails/BankDetailsForm";

export default {
  name: "BankDetailsFormPage",
  components: {
    BankDetailsForm,
  },
};
</script>
